const CrmInteractionsFilters = [
  {
    name: 'Teammates',
    pages: ['CrmInteractions'],
    searchState: 'always',
    filterName: 'addedByUserId',
    prefix: 'myInteractions',
    type: 'teammates',
    options: [{ name: 'Me', useCurrentUserId: true }],
  },
  {
    name: 'Type',
    pages: ['CrmInteractions'],
    searchState: 'always',
    filterName: 'interactionType',
    prefix: 'type',
    options: [
      { name: 'Email' },
      { name: 'Meeting' },
      { name: 'Phone call' },
      { name: 'Social media' },
      { name: 'Event', filterValue: 'Events' },
      { name: 'Other' },
    ],
  },
  {
    name: 'Initiator',
    pages: ['CrmInteractions'],
    searchState: 'always',
    filterName: 'initiator',
    prefix: 'initiator',
    notSendIfOptionsAreSelected: true,
    options: [
      {
        name: '${activePlan.organisationName}',
        agencyOnly: true,
        filter: [{ field: 'initiator', value: 'Agency', operator: 'str_eq' }],
      },
      { name: '${team.teamName}', filter: [{ field: 'initiator', value: 'Team', operator: 'str_eq' }] },
      { name: 'Stakeholder', filter: [{ field: 'initiator', value: 'Stakeholder', operator: 'str_eq' }] },
    ],
  },
  {
    name: 'Stakeholders',
    pages: ['CrmInteractions'],
    searchState: 'always',
    filterName: 'crmContactIds',
    prefix: 'people',
    type: 'membership',
    subtype: 'CrmContacts',
    options: [],
  },
  {
    name: 'Tag',
    pages: ['CrmInteractions'],
    searchState: 'always',
    filterName: 'tags',
    prefix: 'tag',
    type: 'membership',
    subtype: 'CrmInteractionTags',
    options: [],
  },
];

export default CrmInteractionsFilters;
